module.exports = require('./lib/react.js')



//////////////////
// WEBPACK FOOTER
// ./~/glamor/react.js
// module id = 9
// module chunks = 168707334958949